import Vue from 'vue';
import Router from 'vue-router';
import MyArticles from './views/MyArticles.vue';
import MyProfile from './views/MyProfile.vue';
import MyTrials from './views/MyTrials.vue';
import MyCommunities from './views/MyCommunities.vue';
import MyManage from './views/MyManage.vue';
import CreateCommunity from './views/CreateCommunity.vue';
import MyEvents from './views/MyEvents.vue';
import MeetupQR from './views/MeetupQR.vue';
import CreateEditMeetup from "./views/CreateEditMeetup.vue"
import ManageSubmissions from "./views/ManageSubmissions.vue"
import MyPapers from "./views/MyPapers.vue"
import ManageMeetupEmail from "./views/ManageMeetupEmails.vue"
import AgendaBuilder from "./views/AgendaBuilder.vue"
import EditPaper from "./views/EditPaper.vue"
import AttendeesList from "./views/AttendeesList.vue"

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'dashboard',
            redirect: '/profile'
        },
        {
            path: '/profile',
            name: 'profile',
            component: MyProfile,
        },
        // {
        //   path: '/articles',
        //   name: 'articles',
        //   component: MyArticles,
        // },
        {
            path: '/trials',
            name: 'trials',
            component: MyTrials,
        },
        {
            path: '/communities',
            name: 'communities',
            component: MyCommunities,
        },
        {
            path: '/communities/:id/manage',
            name: 'manage',
            component: MyManage,
        },
        {
            path: '/papers',
            name: 'papers',
            component: MyPapers,
        },
        {
            path: '/papers/:paperId/edit',
            name: 'edit-paper',
            component: EditPaper,
        },
        {
            path: '/papers/new',
            name: 'new-paper',
            component: EditPaper,
        },
        {
            path: '/communities/:id/manage/meetups/:meetupid/submissions',
            name: 'manage-submissions',
            component: ManageSubmissions,
        },
        {
            path: '/communities/:id/manage/meetups/:meetupid/agenda',
            name: 'agenda',
            component: AgendaBuilder,
        },
        {
            path: '/communities/:id/manage/meetups/new',
            name: 'meetup-new',
            component: CreateEditMeetup,
        },
        {
            path: '/communities/:id/manage/meetups/:meetupid/edit',
            name: 'meetup-edit',
            component: CreateEditMeetup,
        },
        {
            path: '/communities/:id/manage/meetups/:meetupid/emails',
            name: 'meetup-emails',
            component: ManageMeetupEmail,
        },
        {
            path: '/communities/:id/manage/meetups/:meetupid/checkin',
            name: 'meetup-qr',
            component: MeetupQR,
        },
        {
            path: '/communities/:id/manage/meetups/:meetupid/attendees',
            name: 'meetup-attendees',
            component: AttendeesList,
        },
        {
            path: '/create-community',
            name: 'create-community',
            component: CreateCommunity,
        },
        {
            path: '/events',
            name: 'events',
            component: MyEvents,
        },
    ],
});
